module.exports = "<div class=\"registerBox\">\r\n    <div class=\"registerTitleBox\">\r\n        <div class=\"registerTitle\">{{commonLocal.ChangePassword.register}}\r\n            <a class=\"BackToLogin\" href=\"/#/login\">{{commonLocal.ChangePassword.ReturnToLogin}}</a>\r\n        </div>\r\n    </div>\r\n    <div class=\"registerTitleformBox\">\r\n        <q-form params=\"app:app\"></q-form>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/reg/Reg.html
// module id = 176
// module chunks = 0